<template>
    <div class="container">
        <div class="header-btn">
            <div>
                <el-button type="primary" @click="outerVisible = true">添加新门店</el-button>
                <el-dialog v-model="outerVisible" title="添加新门店" center>
                    <template #default>
                        <el-card shadow="never" class="card-border">
                            <template #header>
                                <div class="card-header">
                                    <span>添加新门店</span>
                                </div>
                            </template>
                            <div class="card-content">
                                <el-form-item label="门店名称:" style="width:292px">
                                    <el-input placeholder="分店名称" />
                                </el-form-item>
                            </div>
                        </el-card>
                    </template>
                    <template #footer>
                        <div class="dialog-footer">
                            <el-button @click="outerVisible = false">取消</el-button>
                            <el-button type="primary" @click="innerVisible = true">
                                确定
                            </el-button>
                        </div>
                    </template>
                </el-dialog>
            </div>
        </div>
    </div>
    <div class="content">
        <el-card shadow="never" class="card-border">
            <template #header>
                <div class="card-header">
                    <span>查询</span>
                </div>
            </template>
            <div>
                <el-form :inline="true" label-width="100px" label-position="right">
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="门店名称:">
                                <el-select placeholder="全部" clearable>
                                    <el-option :value="0" label="门店1" />
                                    <el-option :value="1" label="门店2" />
                                    <el-option :value="2" label="门店3" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="手机号：" style="width:292px">
                                <el-input placeholder="手机号" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="10">
                        </el-col>
                        <el-col :span="4">
                            <div class="search-btn">
                                <el-button type="primary">查询</el-button>
                            </div>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </el-card>
    </div>
    <div class="detail">
        <el-card shadow="never" class="card-border">
            <template #header>
                <div class="card-header">
                    <span>订单明细</span>
                </div>
            </template>
            <div>
                <el-table stripe border style="width: 100%" fit>
                    <el-table-column prop="out_trade_no" label="门店名称">
                    </el-table-column>
                    <el-table-column prop="trade_no" label="店长">
                    </el-table-column>
                    <el-table-column prop="shanghu" label="创建时间">
                    </el-table-column>
                    <el-table-column prop="fendian" label="操作">
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination">
                <el-pagination :page-size="20" :pager-count="7" layout="prev, pager, next" :total="10">
                </el-pagination>
            </div>
        </el-card>
    </div>
</template>

<script setup>
import { ref } from 'vue'

const outerVisible = ref(false)
const innerVisible = ref(false)
</script>

<style lang="less" scoped>
.container {
    .header-btn {
        .card-border {
            border-top: 5px solid #e7e7e7;
            margin-top: 10px;

            .card-header {
                font-size: 15px;
                font-weight: bold;
            }

            .card-content {
                margin-top: 20px;
            }
        }

        .dialog-footer button:first-child {
            margin-right: 10px;
        }
    }

}

.content {
    margin-top: 20px;

    .card-border {
        border-top: 5px solid #e7e7e7;

        .card-header {
            span {
                font-size: 15px;
                font-weight: bold;
            }
        }

    }
}

.detail {
    margin-top: 20px;

    .card-border {
        border-top: 5px solid #e7e7e7;

        .card-header {
            span {
                font-size: 15px;
                font-weight: bold;
            }
        }

        .pagination {
            display: flex;
            justify-content: flex-end;
        }
    }

}
</style>